"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const graphql_tag_1 = tslib_1.__importDefault(require("graphql-tag"));
const graphql_1 = require("..");
exports.createIntegration = graphql_tag_1.default `
  mutation createIntegration($data: IntegrationCreateInput!) {
    createIntegration(data: $data) {
      ...mailjetDetailData
      ...sailthruDetailData
      ...salesforceDetailData
      ...contentSystemDetailData
      ...mailchimpDetailData
      ...campaignMonitorDetailData
      ...activeCampaignDetailData
    }
  }
  ${graphql_1.mailjetDetailData}
  ${graphql_1.contentSystemDetailData}
  ${graphql_1.sailthruDetailData}
  ${graphql_1.salesforceDetailData}
  ${graphql_1.mailchimpDetailData}
  ${graphql_1.campaignMonitorDetailData}
  ${graphql_1.activeCampaignDetailData}
`;
exports.deleteIntegration = graphql_tag_1.default `
  mutation deleteIntegration($id: ID!) {
    deleteIntegration(id: $id)
  }
`;
exports.espSendCampaign = graphql_tag_1.default `
  mutation espSendCampaign($data: ESPCreateCampaignData!) {
    espSendCampaign(data: $data) {
      espUrl
      espId
    }
  }
`;
exports.espCreateCampaign = graphql_tag_1.default `
  mutation espCreateCampaign($data: ESPCreateCampaignData!) {
    espCreateCampaign(data: $data) {
      espUrl
      espId
      email {
        id
        emailNumber
      }
    }
  }
`;
exports.espSendCampaignTest = graphql_tag_1.default `
  mutation espSendCampaignTest($data: ESPCreateCampaignData!) {
    espSendCampaignTest(data: $data) {
      espUrl
      espId
    }
  }
`;
exports.sendCampaign = graphql_tag_1.default `
  mutation sendCampaign($data: SendCampaignInputData!) {
    sendCampaign(data: $data) {
      espUrl
      espId
    }
  }
`;
exports.espTestConnection = graphql_tag_1.default `
  mutation espTestConnection($id: ID!) {
    espTestConnection(id: $id) {
      ...mailjetDetailData
      ...sailthruDetailData
      ...salesforceDetailData
      ...contentSystemDetailData
      ...mailchimpDetailData
      ...campaignMonitorDetailData
      ...activeCampaignDetailData
    }
  }
  ${graphql_1.mailjetDetailData}
  ${graphql_1.contentSystemDetailData}
  ${graphql_1.sailthruDetailData}
  ${graphql_1.salesforceDetailData}
  ${graphql_1.mailchimpDetailData}
  ${graphql_1.campaignMonitorDetailData}
  ${graphql_1.activeCampaignDetailData}
`;
exports.espGetListSubscribers = graphql_tag_1.default `
  mutation espGetListSubscribers($espId: ID!, $listId: ID!, $options: JSON!) {
    espGetListSubscribers(espId: $espId, listId: $listId, options: $options)
  }
`;
exports.espPushListSubscribers = graphql_tag_1.default `
  mutation espPushListSubscribers($espId: ID!, $listId: ID!, $options: JSON!) {
    espPushListSubscribers(espId: $espId, listId: $listId, options: $options)
  }
`;
exports.getMailchimpBatchJobStatus = graphql_tag_1.default `
  mutation getMailchimpBatchJobStatus($espId: ID!, $batchId: String!) {
    getMailchimpBatchJobStatus(espId: $espId, batchId: $batchId)
  }
`;
//# sourceMappingURL=integrations.js.map